import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { Button } from "@datapay-by-datacom/design-system";
import { useCompanyConfigs } from "../hooks";
import s from "./CompanyConfigListScreen.module.css";

/** Landing screen for the onboarding portal — the company configuration list. */
export function CompanyConfigListScreen() {
  const navigate = useNavigate();
  const { data: configs, isLoading, isError } = useCompanyConfigs();

  return (
    <div className={s.container}>
      <header className={s.header}>
        <div className={s.headerText}>
          <h1 className={s.title}>Company Configurations</h1>
          <p className={s.subtitle}>
            Versioned configuration profiles used to onboard companies.
          </p>
        </div>
        <Button variant="primary" onPress={() => navigate("/onboarding/new")}>
          New company configuration
        </Button>
      </header>

      {isLoading && (
        <p className={s.status}>Loading company configurations…</p>
      )}
      {isError && (
        <div className={s.error} role="alert">
          Could not load company configurations.
        </div>
      )}

      {configs && configs.length === 0 && (
        <p className={s.empty}>
          No company configurations yet. Create the first one.
        </p>
      )}

      {configs && configs.length > 0 && (
        <ul className={s.list}>
          {configs.map((config) => (
            <li key={config.config_code} className={s.item}>
              <Link
                to={`/onboarding/${config.config_code}`}
                className={s.itemLink}
              >
                <span className={s.itemName}>{config.display_name}</span>
                <span className={s.itemMeta}>
                  {config.config_code} · v{config.version} · {config.status}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
